import { Navigate, useLocation } from "react-router";
import { getUserStorage } from "util/local_storage";

/**
 * A wrapper for routes that require authentication.
 * Redirects to the login page if the user is not authenticated.
 * Token checking and refresh is handled automatically by ApiClient before each API call.
 * @param {object} props - The component props.
 * @param {Element} props.children - The child components to render if authenticated.
 * @returns {Element} The rendered component.
 */
export default function PrivateRoute({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const user = getUserStorage();
  const isAuthenticated = !!user?.accessToken;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return children;
}
